/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>黑名单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="phone" placeholder="请输入会员手机号"></el-input>
      </el-form-item>-->

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="addBlackUser">添加黑名单</el-button>
      </el-form-item> 
    </el-form>
    <!--列表-->
    <el-table size="small" :data="menberList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="phone" label="手机号" width="400" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="question" label="创建时间" width="400" show-overflow-tooltip >
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="80" >
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">预览</el-button> -->
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="手机号">
              <el-input size="small" v-model="addPhone" auto-complete="off" placeholder="请输入手机号" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from '../../api/payMG'
import Pagination from '../../components/Pagination'

import {getGoodsList,getGoodsTypeList,getMemberList,getBlackList,addBlack,deleteBlack} from '@/api/api.js'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      date:'',
      year:'',
      month:'',
      day:'',
      goodsStatus:'',//商品类型
      payway: [
        { key: '全部订单', value: 0 },
        { key: '已完成订单', value: 1 },
        { key: '已取消订单', value: 2 },
        { key: '已退款订单', value: 3 },
      ],
      goodsTypeList:[],//商品类型列表
      orderList:'',//订单列表
      phone:'',//会员手机号
      goodsList:[],//商品列表
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: '',
        orderNo: '',
        transId: '',
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem('logintoken')
      },
      addPhone:'',
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
   // this.getGoodsType();//获取商品类型列表
    this.getData();//获取商品列表
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取商品类型列表
    getGoodsType(){
      getGoodsTypeList().then((res)=>{
        //改变数组里元素的某个属性
        res.data.forEach((item)=>{
          item.key = item.name
          item.value = item.id
        })
        //在数组开头添加一个元素
        res.data.unshift({key:'所有',value:''})
        this.goodsTypeList = res.data
      })
    },
  //获取黑名单列表
    getData(){
      this.loading = true
      getBlackList({
      }).then((res)=>{
        if(res)
        //改变数组里元素的某个属性
        // res.data.records.forEach((item)=>{
        //   item.payMethod = item.payMethod == 0 ? '微信' : '支付宝'
        //   item.orderStatus = item.orderStatus == 1 ? '已完成' : '生成中'
        //   item.newContent = item.content.replace(/\\n/g, '<br>')
        // })
        
        this.menberList = res.data
        this.loading = false
        this.pageparm.currentPage = this.formInline.page
        this.pageparm.pageSize = this.formInline.limit
        this.pageparm.total = res.data.total

      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = 10
      // this.getdata(this.formInline)
      this.getData()
    },
    // 添加黑名单
    addBlackUser(){
      //打开对话框
      this.editFormVisible = true
      this.title = '添加黑名单'
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
      console.log(index,row,'333333')
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      //添加黑名单
      addBlack({
        phone:this.addPhone,
        storeId:localStorage.getItem('storeId')
      }).then((res)=>{
        if(res.code == 0){
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.editFormVisible = false
          this.getData()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteBlack({
            phone:row.phone
          })
            .then(res => {
              if (res.code==0) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      // this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/system/blackUser.vue